// 커뮤니티 도메인 상수·카피·포맷 규칙 — 도메인 코어 정본

export const PER_PAGE = 20;
export const CATEGORIES = ["전체", "자유", "질문", "정보", "유머", "시장", "투자"];
export const POST_CATEGORIES = ["자유", "질문", "정보", "유머", "시장", "투자"];
export const SUBCATEGORIES: Record<string, string[]> = {
  "시장": ["시황", "뉴스", "실적"],
  "투자": ["주식", "가상화폐", "부동산"],
};

// 캐릭터 자산 디렉토리 — slug → public/redesign-assets/char/<dir> (CastAvatar id와 1:1)
export const CHAR_DIRS: Record<string, string> = {
  kkami: "01-kkami", bbiyong: "02-bbiyong", ryan: "03-ryan", kongi: "04-kongi",
  roki: "05-roki", tobi: "06-tobi", lumi: "07-lumi", mio: "08-mio",
  yeouni: "09-yeouni", hwangdoongi: "10-hwangdoongi", bugi: "11-bugi",
};

/** AI 봇 페르소나 → 얼굴로 쓰는 캐릭터.
 *
 *  ⚠ **봇 여부를 이 캐릭터 ID로 판정하지 말 것.** 판정은 서버가 준 `author_is_bot`
 *  (= `profiles.is_bot`)이 유일한 근거다. 여기 있는 캐릭터는 유저도 무료 기본 아바타·가챠 카드로
 *  장착할 수 있으므로(`CardCollectionScreen` 기본 아바타 11종), 얼굴은 봇의 증거가 되지 못한다.
 *
 *  종전에 CommunityScreen·PostDetailScreen·HomeScreen 세 곳에 같은 함수가 복사돼 있었다
 *  (2026-09-09 통합). 한 곳만 고치면 나머지 두 화면이 조용히 어긋나던 구조였다. */
export const BOT_PRESENTATION: Record<string, { castId: string }> = {
  analyst: { castId: "hwangdoongi" },  // 분석봇 — 장 마감 요약·주간 캘린더
  event: { castId: "bbiyong" },        // 속보봇 — 이벤트 반응
};

/** 봇 페르소나(+작성자명 폴백) → 캐릭터 slug.
 *  persona가 비어 오는 구버전 행을 위해 작성자명 '삐용' 포함 여부를 2차로 본다. */
export function botCastId(persona: string | null | undefined, author?: string | null): string {
  const byPersona = persona ? BOT_PRESENTATION[persona] : undefined;
  if (byPersona) return byPersona.castId;
  if (author && author.includes("삐용")) return BOT_PRESENTATION.event.castId;
  return BOT_PRESENTATION.analyst.castId;
}

export type RpcError = { code: string; word?: string; message: string };

/** 오늘이면 HH:MM, 아니면 MM.DD — now 필수(하이드레이션 안전 수동 포맷 유지) */
export function formatPostDate(dateStr: string | null | undefined, now: Date): string {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (d.toDateString() === now.toDateString()) {
    const hh = d.getHours().toString().padStart(2, "0");
    const mm = d.getMinutes().toString().padStart(2, "0");
    return `${hh}:${mm}`;
  }
  return `${(d.getMonth() + 1).toString().padStart(2, "0")}.${d.getDate().toString().padStart(2, "0")}`;
}

export function parseRpcError(error: unknown): RpcError | null {
  if (!error) return null;
  const msg = typeof error === "object" && "message" in error
    ? String((error as { message?: unknown }).message || "")
    : "";
  if (msg.includes("BAD_WORD_DETECTED")) {
    const word = msg.split("BAD_WORD_DETECTED:")[1]?.split("\n")[0]?.trim() || "";
    return { code: "BAD_WORD", word, message: `부적절한 표현이 포함되어 있습니다 (${word})` };
  }
  if (msg.includes("AUTH_REQUIRED")) return { code: "AUTH_REQUIRED", message: "로그인이 필요합니다" };
  if (msg.includes("DUPLICATE_REPORT")) return { code: "DUPLICATE_REPORT", message: "이미 신고한 콘텐츠입니다 (1시간 후 재시도)" };
  return { code: "UNKNOWN", message: msg };
}
